import { useEffect } from "react";

export default function RedemptionModalSuccess() {
  useEffect(() => {
    const successModal = document.getElementById('redemption-success-modal');
    successModal.addEventListener('hide.bs.modal', e => {
      window.location.reload();
    });
  }, []);

  return (
    <div
      className="modal fade"
      tabIndex="-1"
      aria-hidden="true"
      aria-label="Redemption Success"
      id="redemption-success-modal"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body px-md-4">
            <div className="vstack gap-4">
              <p className="subhead-1 text-primary mb-1">
                Prime Token Redemption
              </p>
              <div>
                <span className="d-block h2 mb-2">Your Redemption is complete!</span>
                <p className="fs-lg">
                  A confirmation email will be sent to your inbox.
                </p>
              </div>
            </div>
          </div>
          <div className="modal-footer px-md-4">
            <button
              className="btn btn-primary"
              data-bs-dismiss="modal"
              aria-label="Close"
              type="button"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
